// extracted by mini-css-extract-plugin
export default {"container":"BK-z","topReviewHeading":"CK-z","criticalReview":"DK-z","favorableReview":"EK-z","vsSeparator":"FK-z"};